<template>
    <section class="menu-sliders-main">
        <section class="slider slider-menu" :class="{'active': slider == 'home'}">
            <section class="menu-slider">
                <button v-for="(item, index) in menu" :key="index" type="button" 
                    :class="{'active': menuActive === item.key}" 
                    @click="open(item.key)"  
                    :disabled="shouldDisableButton(index)"
            >
                <div class="icon">
                    <i :class="item.icon"/>
                </div>
                {{item.title}}
            </button>
            </section>
        </section>
        <section
            v-for="(item, mindex) in menu"
            :key="mindex"
            class="slider slider-submenu"
            :class="{
                'active': slider === item.key
            }"
        >
            <div class="nav">
                <button type="button" @click="open('home')"><i class="far fa-chevron-left"/></button>
                <h3>{{item.title}}</h3>
            </div>
            <section v-if="item.submenu" class="submenu" :class="{'scroll-color': item.key == 'clientes' && sidebarLeft}">
                <router-link v-for="(submenu, sindex) in item.submenu" :key="sindex" :to="submenu.url" >
                    <span>{{submenu.label}}</span>
                    <span><i class="fal fa-chevron-right"/></span>
                </router-link>
            </section>
        </section>
    </section>
</template>

<script>

	export default {
		name: "ui-menu-slider",
		props: {
			menu: {},
			menuActive: {},
            permissions: {}
		},

		data() {
			return {
				sliderActive: null,
			    sidebarLeft: true,
                buttonText: 'Configurações Avançadas'
			}
		},

		computed: {
			slider(){
				return this.sliderActive ? this.sliderActive : this.menuActive
			}
		},

        mounted() {
			this.$root.$on('toogle-sidebar-left', payload =>
                this.sidebarLeft = payload
            )
        },

		methods:{
            isLastItem(index) {
                return index === this.menu.length - 1;
            },

            open(key){
                 this.sliderActive = key
            },
            shouldDisableButton(index) {
                // Verifica se é o último item do menu ( configurado para ser o botao de configuracoes avancadas)
                const isLast = index === this.menu.length - 1; 
                // Verifica se tem permissões e se tem o campo super_admin
                const hasPermissions = this.permissions && this.permissions.super_admin === 1; 

                if (isLast) {
                    if (hasPermissions) {
                        // Não desabilita se for o último item e tiver permissões de super admin
                        return false; 
                    } else {
                        // Desabilita se for o último item e não tiver permissões de super admin
                        return true; 
                    }
                } else {
                     // Não desabilita se não for o último item
                    return false;
                }
            }
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>